import React, { useState } from 'react';
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Link } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import useAnimatedNavToggler from "../../helpers/useAnimatedNavToggler.js";
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import './style.css';
import { useLocation } from 'react-router-dom';
import logo from "../../images/latest/logo.svg";

// import logo from "../../images/logo.svg";
import { ReactComponent as MenuIcon } from "feather-icons/dist/icons/menu.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
export const StyledLink = tw(Link)`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500
  max-w-full
`;



const Header = tw.header`
  flex justify-between items-center
  max-w-screen-xl mx-auto
  overflow-hidden
  px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12
`;

// export const NavLinks = tw.div`
//   inline-block
//   w-full lg:w-auto
//   text-center lg:text-left
//   max-w-full
//   whitespace-nowrap
// `;
export const NavLinks = tw.div`
  flex
  flex-wrap
  items-center
  w-full lg:w-auto
  text-center lg:text-left
  max-w-full
  whitespace-nowrap
  text-xs sm:text-sm md:text-sm lg:text-sm xl:text-sm`;
/* hocus: stands for "on hover or focus"
 * hocus:bg-primary-700 will apply the bg-primary-700 class on hover or focus
 */
export const NavLink = tw.a`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500 
`;

export const StyledButton = tw.button`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500 text-black
  focus:text-white active:text-white
  focus:outline-none
  focus-visible:text-white
`;
export const PrimaryLink = tw(NavLink)`
  mx-4 sm:mx-6 md:mx-8 lg:mx-0
  px-8 py-3 rounded-full bg-primary-500 text-gray-100 shadow-md
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0 whitespace-nowrap
  text-xs sm:text-sm md:text-base lg:text-base xl:text-base
`;
export const LogoLink = styled(NavLink)`
  ${tw`flex items-center font-black border-b-0 ml-0!`};
  ${tw`text-xl sm:text-2xl md:text-2xl lg:text-xl xl:text-xl`};

  img {
    ${tw`w-10 mr-3`}
  }
`;

export const MobileNavLinksContainer = tw.nav`flex flex-1 items-center justify-between`;
export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hocus:text-primary-500 transition duration-300
`;
 export const MobileNavLinks = motion(styled.div`
  ${tw`lg:hidden z-10 fixed top-0 inset-x-0 mx-4 my-6 p-8 border text-center rounded-lg text-gray-900 bg-white`}
  ${NavLinks} {
    ${tw`flex flex-col items-center`}
    ${tw`text-xs sm:text-sm md:text-base lg:text-base xl:text-base`}
    ${tw`break-words`}
    max-width: 100%;
  }
`);

export const DesktopNavLinks = tw.nav`
  hidden lg:flex flex-1 justify-between items-center
`;

export default ({ roundedHeaderButton = false, logoLink, links, className, collapseBreakpointClass = "xl" }) => {
  /*
   * This header component accepts an optionals "links" prop that specifies the links to render in the navbar.
   * This links props should be an array of "NavLinks" components which is exported from this file.
   * Each "NavLinks" component can contain any amount of "NavLink" component, also exported from this file.
   * This allows this Header to be multi column.
   * So If you pass only a single item in the array with only one NavLinks component as root, you will get 2 column header.
   * Left part will be LogoLink, and the right part will be the the NavLinks component you
   * supplied.
   * Similarly if you pass 2 items in the links array, then you will get 3 columns, the left will be "LogoLink", the center will be the first "NavLinks" component in the array and the right will be the second "NavLinks" component in the links array.
   * You can also choose to directly modify the links here by not passing any links from the parent component and
   * changing the defaultLinks variable below below.
   * If you manipulate links here, all the styling on the links is already done for you. If you pass links yourself though, you are responsible for styling the links or use the helper styled components that are defined here (NavLink)
   */


  


  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isButtonFocused, setIsButtonFocused] = useState(false);

const [anchorElTherapie, setAnchorElTherapie] = React.useState(null);
const [anchorElOnderzoek, setAnchorElOnderzoek] = React.useState(null);
const navigate = useNavigate();
const [hoveredItem, setHoveredItem] = useState(null); // State for hover effect
console.log(hoveredItem)
const useStyles = makeStyles({
  paper: {
    border: '1px solid lightgrey',
  },
  menuItem: {
    borderBottom: '1px solid lightgrey',
  },
});
const [activeMenuItem, setActiveMenuItem] = useState(null);

  const handleMenuOpenTherapie = (event) => {
    setAnchorElTherapie(event.currentTarget);
  };

  const handleMenuOpenOnderzoek = (event) => {
    setAnchorElOnderzoek(event.currentTarget);
  };
   
  const handleMouseEnter = (index) => {
    setActiveMenuItem(index); // Set active menu item on mouse enter
    setHoveredItem(index); // Set hovered item
  };

  const handleMouseLeave = () => {
    setHoveredItem(null); // Reset hovered item on mouse leave
    setActiveMenuItem(null); // Set active menu item on mouse enter

  };

// In your component
const classes = useStyles();
 
const handleCloseTherapie = React.useCallback(() => {
  setAnchorElTherapie(null);
}, []);


const menuRef = React.useRef(null);

const onderzoekItems = [
  { path: '/onderzoek/adhd', label: 'ADHD' },
  { path: '/onderzoek/autisme', label: 'Autisme' },
  { path: '/onderzoek/tarieven', label: 'Tarieven' },
];

const handleCloseOnderzoek = React.useCallback(() => {
  setAnchorElOnderzoek(null);
}, []);


  const defaultLinks = [
  <NavLinks key={1}>
    <div>
    <StyledButton
        onClick={handleMenuOpenTherapie}
        onFocus={() => setIsButtonFocused(true)}
        onBlur={() => setIsButtonFocused(false)}
        style={{ color: isButtonFocused ? 'black' : 'text-primary-500' }}
      >      Therapie </StyledButton>
      
      <Menu
        id="simple-menu2"
        anchorEl={anchorElTherapie}
        keepMounted
        open={Boolean(anchorElTherapie)}
        onClose={handleCloseTherapie}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: classes.paper }} // Apply the border to the Paper component
      >
        {[
          { path: '/therapie/cgt', label: 'CGT' },
          { path: '/therapie/emdr-ie', label: 'Traumatherapie' },
          { path: '/therapie/kpsp', label: 'KPSP' },
          { path: '/therapie/schrijftherapie', label: 'Schrijftherapie' },
          { path: '/therapie/tarieven', label: 'Tarieven' },
        ].map((item, index) => (
          <MenuItem
          key={index}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          selected={activeMenuItem === index}
          onClick={() => {
            handleCloseTherapie();
            navigate(item.path);
            toggleNavbar();

          }}
        >
            <StyledLink to={item.path}>{item.label}</StyledLink>
          </MenuItem>
        ))}
      </Menu>
    </div>

    <div>
    <StyledButton
        onClick={handleMenuOpenOnderzoek}
        onFocus={() => setIsButtonFocused(true)}
        onBlur={() => setIsButtonFocused(false)}
        style={{ color: isButtonFocused ? 'black' : 'text-primary-500' }}
      >
          Onderzoek
        </StyledButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorElOnderzoek}
          keepMounted
          open={Boolean(anchorElOnderzoek)}
          onClose={handleCloseOnderzoek}
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          ref={menuRef}
          onOpen={() => {
            setTimeout(() => {
              menuRef.current.focus();
            }, 0);
          }}
          classes={{ paper: classes.paper }} // Apply the border to the Paper component
        >
          {onderzoekItems.map((item, index) => (
            <MenuItem
              key={index}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                handleCloseOnderzoek();
                navigate(item.path);
                toggleNavbar();
              }}
            >
              <StyledLink to={item.path}>{item.label}</StyledLink>
            </MenuItem>
          ))}
        </Menu>
      </div>
    <NavLink href="/supervisie">
      Supervisie
    </NavLink>
    

    <NavLink href="/vragen">
      Veel Gestelde Vragen
    </NavLink>
    <PrimaryLink href="/contact">
      Maak een afspraak
    </PrimaryLink>
  </NavLinks>

      
];
  const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
  const collapseBreakpointCss = collapseBreakPointCssMap[collapseBreakpointClass];

  const defaultLogoLink = (
    <LogoLink href="/" className="logo-link"> 
      <img src={logo} alt="logo" />
      Psychologenpraktijk BB
    </LogoLink>
  );

  logoLink = logoLink || defaultLogoLink;
  links = links || defaultLinks;

  return (
    <Header className={className || "header-light"} style={!isHomePage ? { marginTop: "5%" } : {}}>
      <DesktopNavLinks css={collapseBreakpointCss.desktopNavLinks}>
        {logoLink}
        {links}
      </DesktopNavLinks>

      <MobileNavLinksContainer css={collapseBreakpointCss.mobileNavLinksContainer}  >
  <div className="logo-link small-font hidden xl:block">{logoLink}</div>
  <MobileNavLinks 
  initial={{ 
    x: "150%", 
    display: "none", 
    backgroundColor: "#ecf0f1" 
  }} 
  animate={animation} 
  css={collapseBreakpointCss.mobileNavLinks}
>
    {links}
  </MobileNavLinks>
  <NavToggle 
  onClick={toggleNavbar} 
  className={showNavLinks ? "open" : "closed"}
  style={{ position: 'sticky', top: '0', zIndex: '1000' }}
>
  {showNavLinks ? <CloseIcon tw="w-6 h-6" /> : <MenuIcon tw="w-6 h-6" />}
</NavToggle>
</MobileNavLinksContainer>
    </Header>
  );
};

/* The below code is for generating dynamic break points for navbar.
 * Using this you can specify if you want to switch
 * to the toggleable mobile navbar at "sm", "md" or "lg" or "xl" above using the collapseBreakpointClass prop
 * Its written like this because we are using macros and we can not insert dynamic variables in macros
 */

const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`,
    zIndex: '100000000'
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`,
    zIndex: '1000'

  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
    zIndex: '1000'

  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
    zIndex: '1000'

  }
};
